(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-mega-menu"] && !Shopify.designMode) return;
  try {
    const initializeDriverSearch = (root) => {
    root.querySelectorAll('[data-nx-driver-search]').forEach((input) => {
      if (input.dataset.searchReady === 'true') return;
      input.dataset.searchReady = 'true';

      const group = input.closest('.nx-mega-menu__group');
      const items = Array.from(group.querySelectorAll('[data-nx-driver-item]'));
      input.addEventListener('input', () => {
        const query = input.value.trim().toLocaleLowerCase();

        items.forEach((item) => {
          const matches = item.dataset.driverName.includes(query);
          item.hidden = !matches;
        });
      });
    });
  };

  const initializeAllDriverSearch = () => {
    document.querySelectorAll('.nx-mega-menu').forEach(initializeDriverSearch);
  };

  initializeAllDriverSearch();
  document.addEventListener('shopify:section:load', initializeAllDriverSearch);
  } catch(e) { console.error(e); }
})();

})();
